import React, { useState } from 'react';
import { Menu, X } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export function Navbar() {
  const [isOpen, setIsOpen] = useState(false);
  return <nav className="sticky top-0 z-50 w-full bg-lavender/80 backdrop-blur-md border-b border-ink/5" data-id="element-138">
      <div className="max-w-7xl mx-auto px-6 h-20 flex items-center justify-between" data-id="element-139">
        {/* Logo */}
        <a href="#" className="font-serif italic font-bold text-3xl text-ink tracking-tight" data-id="element-140">
          ik.
        </a>

        {/* Desktop Links */}
        <div className="hidden md:flex items-center gap-8" data-id="element-141">
          <a href="https://go.inkovacreation.com/" target="_blank" rel="noopener noreferrer" className="text-ink font-medium hover:text-accent transition-colors" data-id="element-142">
            Planes
          </a>
          <a href="#testimonios" className="text-ink font-medium hover:text-accent transition-colors" data-id="element-143">
            Testimonios
          </a>
          <a href="#faq" className="text-ink font-medium hover:text-accent transition-colors" data-id="element-144">
            FAQ
          </a>
        </div>

        {/* Desktop CTA */}
        <div className="hidden md:block" data-id="element-145">
          <a href="https://inkovacreation.store/shop/aaee3cf3-82b8-4d25-9f96-f42edc2ac2a0" target="_blank" rel="noopener noreferrer" className="inline-block bg-accent hover:bg-ink text-white px-7 py-3.5 rounded-full font-semibold transition-all shadow-soft hover:shadow-lg transform hover:-translate-y-0.5" data-id="element-146">
            Quiero mi guía
          </a>
        </div>

        {/* Mobile Toggle */}
        <button className="md:hidden text-ink p-2" onClick={() => setIsOpen(!isOpen)} aria-label="Toggle menu" data-id="element-147">
          {isOpen ? <X size={24} data-id="element-148" /> : <Menu size={24} data-id="element-149" />}
        </button>
      </div>

      {/* Mobile Menu */}
      <AnimatePresence data-id="element-150">
        {isOpen && <motion.div initial={{
        opacity: 0,
        height: 0
      }} animate={{
        opacity: 1,
        height: 'auto'
      }} exit={{
        opacity: 0,
        height: 0
      }} className="md:hidden bg-white border-b border-ink/5 overflow-hidden" data-id="element-151">
            <div className="px-6 py-6 flex flex-col gap-4" data-id="element-152">
              <a href="https://go.inkovacreation.com/" target="_blank" rel="noopener noreferrer" onClick={() => setIsOpen(false)} className="text-lg font-medium text-ink" data-id="element-153">
                Planes
              </a>
              <a href="#testimonios" onClick={() => setIsOpen(false)} className="text-lg font-medium text-ink" data-id="element-154">
                Testimonios
              </a>
              <a href="#faq" onClick={() => setIsOpen(false)} className="text-lg font-medium text-ink" data-id="element-155">
                FAQ
              </a>
              <a href="https://inkovacreation.store/shop/aaee3cf3-82b8-4d25-9f96-f42edc2ac2a0" target="_blank" rel="noopener noreferrer" onClick={() => setIsOpen(false)} className="bg-accent text-white px-7 py-3.5 rounded-full font-semibold mt-4 w-full text-center" data-id="element-156">
                Quiero mi guía
              </a>
            </div>
          </motion.div>}
      </AnimatePresence>
    </nav>;
}